import {getDynatraceName, getLogo, getDynatraceLogo} from "helpers/component_helpers";
import React, {Fragment, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from 'react-router';
import {threshold_types as THRESHOLD_TYPE} from "constants/data_types";
import deployAlertsLottie from '../../assets/images/deploy_alerts_lottie.json';
import savingDefaultsLottie from '../../assets/images/saving_defaults_lottie.json';
import connectTeamLottie from '../../assets/images/connect_team_lottie.json';
import {showNotification} from "components/Common/notification";
import {
    postDynatraceEnableDisableAlerts as onPostDynatraceEnableDisableAlerts,
    postDynatraceCreateResourceAlerts as onPostDynatraceCreateResourceAlerts,
    postDynatraceCreateDynamicAlert as onDeployDynatraceDynamicAlertsByResourceID,
    getDynatraceAlerts as onGetDynatraceAlerts,
    getDynatraceDynamicAlerts as onGetDynatraceDynamicAlerts,
    getDynatraceMissingDynamicAlerts as onGetDynatraceMissingDynamicAlerts,
    getDynatraceDefaultThreshold as onGetDynatraceDefaultThreshold,
    getDynatraceResourceById as onGetDynatraceResourceById,
    getDynatraceResourcesDefaultThresholdById,
    postDynatraceAlert as onPostDynatraceAlert,
    getMissingDynatraceAlertsByResourceID as onGetDynatraceMissingAlertsByResourceID,
    postDynatraceServiceMapping as onPostDynatraceServiceMapping,
    postDynatraceResourceOpsGenieTeamMapping as onPostDynatraceResourceOpsGenieTeamMapping,
    postDynatraceResourcePagerdutyMapping as onPostDynatraceResourcePagerdutyMapping
} from "store/dynatrace/actions";


import {
    getServices as onGetServices,
    getNotificationChannel as onGetNotificationChannel,
    getPagerDutyServices as onGetPagerDutyServices,
    getOpsGenieTeams as onGetOpsGenieTeams
} from "store/actions";
import {
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    CardBody,
    CardTitle,
    Col,
    Modal, ModalHeader,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Tooltip, UncontrolledAccordion, Table, Button, UncontrolledTooltip
} from "reactstrap";
import Card from "components/PurpleTheme/Card";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Switch from "react-switch";
import Loader from "../../components/Loader/Loader";
import Select from "react-select";
import {Link} from "react-router-dom";
import classnames from "classnames";

const DynatraceAlert = () => {
    const params = useParams()
    const {dynatrace_resource} = useSelector(state => ({
        dynatrace_resource: state.Dynatrace.dynatrace_resource || {},
    }));

    const {alerts} = useSelector(state => ({
        alerts: state.Dynatrace.dynatrace_alerts || [],
    }));

    const {dynatrace_dynamic_alerts} = useSelector(state => ({
        dynatrace_dynamic_alerts: state.Dynatrace.dynatrace_dynamic_alerts || {},
    }));

    const {dynatrace_missing_dynamic_alerts} = useSelector(state => ({
        dynatrace_missing_dynamic_alerts: state.Dynatrace.dynatrace_missing_dynamic_alerts || {},
    }));

    const {notification_channel} = useSelector(state => ({
        notification_channel: state.Service.notification_channel
    }));

    const {dynatrace_resource_missing_alerts} = useSelector(state => ({
        dynatrace_resource_missing_alerts: state.Dynatrace.dynatrace_resource_missing_alerts || {}
    }))

    const {dynatrace_resource_default_threshold} = useSelector(state => ({
        dynatrace_resource_default_threshold: state.Dynatrace.dynatrace_resource_default_threshold || [],
    }));


    const reduxPagerdutyServices = useSelector(state =>
        state.Service.pagerduty_services
    );

    const reduxOpsgenieTeams = useSelector(state =>
        state.OpsGenieTeams.opsgenie_teams
    );

    const reduxServices = useSelector(state =>
        state.Service.services
    );

    const dispatch = useDispatch();
    const [subscribemodal, setSubscribemodal] = useState(false);
    const [deployModalDynamic, setDeployModalDynamic] = useState(false);
    const [changedValues, setchangedValues] = useState({});
    const [changedValuesDynamic, setchangedValuesDynamic] = useState({});
    const [changedValuesMissing, setchangedValuesMissing] = useState({});
    const [mapServiceModal, setMapServiceModal] = useState(false);
    const [serviceOptions, setServiceOptions] = useState([]);
    const [selectedService, setSelectedService] = useState(null);
    const [selectedEnvironment, setSelectedEnvironment] = useState(null);
    const [isLoading1, setIsLoading1] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);
    const [DynatraceDeployModal, setDynatraceDeployModal] = useState(false);
    const [ttop, settop] = useState(false);
    const [dttop, setdtop] = useState(false);
    const [tright, settright] = useState(false);
    const [showToolTip, setShowToolTip] = useState(false);
    const [finalServices, setFinalServices] = useState({})
    const [opsgenieTeams, setOpsgenieTeams] = useState([]);
    const [pagerdutyServices, setPagerdutyServices] = useState([]);
    const [services, setServices] = useState([]);
    const [primaryChannel, setPrimaryChannel] = useState(null);
    const [btnHover, setBtnHover] = useState(false);

    const [tanomaly, settanomaly] = useState(false);
    const [activeTab, setactiveTab] = useState("1");

    const [defaultOpen, setDefaultOpen] = useState(alerts?.length === 0 ? '2' : '1');
    const [accordionKey, setAccordionKey] = useState(0);
    const [accordionKeyDynamic, setAccordionKeyDynamic] = useState(0);
    const [defaultOpenDynamic, setDefaultOpenDynamic] = useState(dynatrace_dynamic_alerts.alerts?.length === 0 ? '2' : '1');
    const [tooltipstatic, setTooltipstatic] = useState({});
    const [tooltipdynamic, setTooltipdynamic] = useState({});
    const [toggles, setToggles] = useState({});
    const [togglesDynamic, setTogglesDynamic] = useState({});
    const [isLoading_DisableAlert, setisLoading_DisableAlert] = useState(false);
    const [isLoading_EnableAlert, setIsLoading_EnableAlert] = useState(false);
    const [valueError, setValueError] = useState({
        samples: '',
        violating_samples: '',
        dealerting_samples: ''
    });
    const headers = ['Metric Name', 'Operator', 'Threshold Value','Unit','Samples','Violating Samples','Action']
    const headersDynamic = ['Metric Name', 'Baseline Direction', 'Deviation Count', 'Duration', 'Action']
    const [isLoading_SaveAlert, setIsLoading_SaveAlert] = useState(false);

    let environments = [
        {value: 'PRODUCTION', label: 'PRODUCTION'},
        {value: 'UAT', label: 'UAT'},
        {value: 'STAGING', label: 'STAGING'},
        {value: 'PREPROD', label: 'PREPROD'},
        {value: 'DEV', label: 'DEV'},
        {value: 'OTHER', label: 'OTHER'},
    ]

    const changeHeaders = ['Key', 'Old Value', 'New Value']

    const ThresholdCondition = ['ABOVE', 'BELOW']

    const ThresholdConditionDynamic = ['LOWER_ONLY', 'UPPER_AND_LOWER', 'UPPER_ONLY']

    const ThresholdType = ['Static', 'Dynamic']

    useEffect(() => {
        dispatch(onGetDynatraceAlerts(params.resourceId));
    }, [onGetDynatraceAlerts]);

    useEffect(() => {
        dispatch(onGetDynatraceDynamicAlerts(params.resourceId));
    }, [onGetDynatraceDynamicAlerts]);

    useEffect(() => {
        dispatch(onGetDynatraceMissingDynamicAlerts(params.resourceId));
    }, [onGetDynatraceMissingDynamicAlerts]);

    useEffect(() => {
        dispatch(onGetDynatraceDefaultThreshold(THRESHOLD_TYPE.STATIC));
    }, [onGetDynatraceDefaultThreshold]);

    useEffect(() => {
        dispatch(onGetServices());
    }, [onGetServices]);

    useEffect(() => {
        dispatch(onGetNotificationChannel());
    }, [onGetNotificationChannel]);

    useEffect(() => {
        dispatch(onGetPagerDutyServices());
    }, [onGetPagerDutyServices]);

    useEffect(() => {
        dispatch(onGetOpsGenieTeams());
    }, [onGetOpsGenieTeams]);

    useEffect(() => {
        dispatch(onGetDynatraceMissingAlertsByResourceID(params.resourceId));
    }, [onGetDynatraceMissingAlertsByResourceID]);

    useEffect(() => {
        const initialTooltipDynamic = {};
        dynatrace_missing_dynamic_alerts.alerts?.forEach(alert => {
            initialTooltipDynamic[alert.id] = false;
        });
        setTooltipdynamic(initialTooltipDynamic);
    }, [dynatrace_missing_dynamic_alerts]);

    useEffect(() => {
        setOpsgenieTeams(reduxOpsgenieTeams);
    }, [reduxOpsgenieTeams]);

    useEffect(() => {
        setPagerdutyServices(reduxPagerdutyServices);
    }, [reduxPagerdutyServices]);

    useEffect(() => {
        setServices(reduxServices);
    }, [reduxServices]);

    useEffect(() => {
        const primaryChannel = notification_channel?.find(channel => channel.is_primary);
        setPrimaryChannel(primaryChannel)
    }, [notification_channel])

    useEffect(() => {
        if (dynatrace_resource?.environment) {
            setSelectedEnvironment(dynatrace_resource?.environment);
        } else setSelectedEnvironment(null);
    }, [onGetDynatraceAlerts]);

    useEffect(() => {
        const initialToggles = {};
        alerts.forEach(alert => {
            initialToggles[alert.id] = alert.enabled;
        });
        setToggles(initialToggles);
    }, [alerts]);

    useEffect(() => {
        if (services && pagerdutyServices && opsgenieTeams && notification_channel && dynatrace_resource) {
            const matchingServices = services.find(service => service?.id === dynatrace_resource?.application_service_id);
            const matchingPagerDutyService = pagerdutyServices.find(service => service?.id === dynatrace_resource?.pagerduty_service_id);
            const matchingOpsgenieServices = opsgenieTeams.find(service => service?.id === dynatrace_resource?.opsgenie_team_id);
            const matchingNotificationChannel = notification_channel.find(channel => channel?.is_primary === true);

            if (matchingNotificationChannel) {
                if (matchingNotificationChannel.name === "Email") {
                    setFinalServices(matchingServices || {});
                } else if (matchingNotificationChannel.name === "PagerDuty") {
                    setFinalServices(matchingPagerDutyService || {});
                } else if (matchingNotificationChannel.name === "OpsGenie") {
                    setFinalServices(matchingOpsgenieServices || {});
                } else {
                    setFinalServices({});
                }
            }
        }
    }, [services, pagerdutyServices, opsgenieTeams, notification_channel, dynatrace_resource]);

    useEffect(() => {
        const matchingNotificationChannel = notification_channel?.find(channel => channel?.is_primary === true);
        if (matchingNotificationChannel) {
            if (matchingNotificationChannel.name === "Email") {
                const options = services?.map((service) => ({
                    value: service.id,
                    label: service.name
                }));
                setServiceOptions(options);
                const initialSelectedService = services?.find(service => service.id === dynatrace_resource?.application_service_id);
                setSelectedService(initialSelectedService?.name);
            } else if (matchingNotificationChannel.name === "PagerDuty") {
                const options = pagerdutyServices?.map((service) => ({
                    value: service.id,
                    label: service.name
                }));
                setServiceOptions(options);
                const initialSelectedService = pagerdutyServices?.find(service => service.id === dynatrace_resource?.pagerduty_service_id);
                setSelectedService(initialSelectedService?.name);
            } else if (matchingNotificationChannel.name === "OpsGenie") {
                const options = opsgenieTeams?.map((service) => ({
                    value: service.id,
                    label: service.name
                }));
                setServiceOptions(options);
                const initialSelectedService = opsgenieTeams?.find(service => service?.id === dynatrace_resource?.opsgenie_team_id);
                setSelectedService(initialSelectedService?.name);
            }
        }

    }, [services, pagerdutyServices, opsgenieTeams, notification_channel, onGetDynatraceAlerts, onGetDynatraceResourceById]);
    useEffect(() => {
        dispatch(onGetDynatraceResourceById(params.resourceId));
    }, [onGetDynatraceResourceById]);

    useEffect(() => {
        dispatch(getDynatraceResourcesDefaultThresholdById(params.resourceId));
    }, [getDynatraceResourcesDefaultThresholdById]);

    const handleMapApplicationService = () => {
        setMapServiceModal(true);
    }

    const cancelMapServiceModal = () => {
        setMapServiceModal(false);
    }

    const handleServiceFormChange = (selectedOption) => {
        setSelectedService(selectedOption);
    };

    const handleServiceMapping = async () => {
        const matchingNotificationChannel = notification_channel?.find(channel => channel?.is_primary === true);
        if (matchingNotificationChannel?.name === 'Email') {
            let payload = {
                'dynatrace_resource_ids': [params.resourceId],
                'application_service_id': selectedService?.value || serviceOptions?.find(option => option.label === selectedService)?.value || '',
                'environment': selectedEnvironment?.value || 'PRODUCTION',
            };
            await dispatch(onPostDynatraceServiceMapping(payload));
            setMapServiceModal(false);
        } else if (matchingNotificationChannel?.name === 'PagerDuty') {
            let payload = {
                'dynatrace_resource_ids': [params.resourceId],
                'pagerduty_service_id': selectedService?.value || serviceOptions?.find(option => option.label === selectedService)?.value || '',
                'environment': selectedEnvironment?.value || 'PRODUCTION',
            };
            await dispatch(onPostDynatraceResourcePagerdutyMapping(payload));
            setMapServiceModal(false);
        } else if (matchingNotificationChannel?.name === 'OpsGenie') {
            let payload = {
                'dynatrace_resource_ids': [params.resourceId],
                'opsgenie_team_id': selectedService?.value || serviceOptions?.find(option => option.label === selectedService)?.value || '',
                'environment': selectedEnvironment?.value || 'PRODUCTION',
            };
            await dispatch(onPostDynatraceResourceOpsGenieTeamMapping(payload));
            setMapServiceModal(false);
        }
    }

    const handleEnvironmentChange = (selectedOption) => {
        setSelectedEnvironment(selectedOption);
    }

    const handleSave = () => {
        setSubscribemodal(true);
    };

    const handleSaveDynamic = () => {
        setDeployModalDynamic(true);
    }

    const handleDefaultDeploy = () => {
        setDynatraceDeployModal(true);
    }

    const cancelDeployModal = () => {
        setDynatraceDeployModal(false);
    }

    const customOptionRenderer = (option) => {
        if (option.value === "/add-service") {
            return (
                <div
                    className="d-flex justify-content-center align-items-center gap-2 btn btn-soft-primary"
                    onMouseEnter={() => setBtnHover(true)}
                    onMouseLeave={() => setBtnHover(false)}
                    style={{cursor: "pointer"}}>
                    <i className={`fas fa-plus font-size-14 ${btnHover ? 'text-white' : 'text-primary'}`}/>
                    <span>
            {option.label}
          </span>
                </div>
            );
        } else {
            return option.label;
        }
    };

    const showTooltipDynamic = (alertId) => {
        setTooltipdynamic({
            ...tooltipdynamic,
            [alertId]: true,
        });
    };

    const hideTooltipDynamic = (alertId) => {
        setTooltipdynamic({
            ...tooltipdynamic,
            [alertId]: false,
        });
    };
    const showTooltipStatic = (alertId) => {
        setTooltipstatic({
            ...tooltipstatic,
            [alertId]: true,
        })
    }

    const hideTooltipStatic = (alertId) => {
        setTooltipstatic({
            ...tooltipstatic,
            [alertId]: false,
        })
    }

    const startLoading1 = () => {
        setIsLoading1(true);
        setTimeout(() => {
            setIsLoading1(false);
            showNotification("success", "Resource Details are updated successfully");
        }, 4000);
    };

    const startLoading2 = () => {
        setIsLoading2(true);
        setTimeout(() => {
            setIsLoading2(false);
        }, 4000);
    };

    const handleDeployDynamicAlert = (resource_id, threshold_id) => {
        const payload = {
            'dynatrace_resource_ids': resource_id,
            'threshold_id': threshold_id,
        }
        dispatch(onDeployDynatraceDynamicAlertsByResourceID(payload));
    };


    const handleDeploy = () => {
        if (dynatrace_resource?.application_service_email_id !== null || dynatrace_resource?.opsgenie_team_id !== null || dynatrace_resource?.pagerduty_service_id !== null) {
            var resourceId = dynatrace_resource?.id;
            var payload = {
                'dynatrace_resource_ids': [resourceId],
            }
            dispatch(onPostDynatraceCreateResourceAlerts(payload));
        }
        setDynatraceDeployModal(false);
    }

    const handleSubmit = () => {
        var alerts_update = []
        Object.entries(changedValues).map(([parent_key, changedValue], index) => {
            var payload = {}
            Object.entries(changedValue).map(([key, value], index2) => {
                payload['alert_id'] = value.id
                payload[value.name] = value.new
            })
            alerts_update.push(payload)
        })
        alerts_update.map((alert, index) => {
            dispatch(onPostDynatraceAlert(alert));
        })
    };

    const handleSubmitDynamic = () => {
        var alerts_update = []
        Object.entries(changedValuesDynamic).map(([parent_key, changedValue], index) => {
            var payload = {}
            Object.entries(changedValue).map(([key, value], index2) => {
                payload['alert_id'] = value.id
                payload[value.name] = value.new
            })
            alerts_update.push(payload)
        })


        alerts_update.map((alert, index) => {
            dispatch(onPostDynatraceAlert(alert));
        })
        setDeployModalDynamic(false);
    };


    const startLoading_SaveAlert = () => {
        setIsLoading_SaveAlert(true);
        setTimeout(() => {
            setIsLoading_SaveAlert(false);
        }, 4000);
    };

    const toggleAlert = (index, alertId) => {
        const updatedToggles = {...toggles};
        updatedToggles[alertId] = !updatedToggles[alertId];
        setToggles(updatedToggles);

        if (!updatedToggles[alertId]) {
            startLoading_DisableAlert();
            handleDisable(alertId)
        } else {
            startLoading_EnableAlert();
            handleEnable(alertId);
        }
    };

    const toggleAlertDynamic = (index, alertId) => {
        const updatedToggles = {...togglesDynamic};
        updatedToggles[alertId] = !updatedToggles[alertId];
        setTogglesDynamic(updatedToggles);

        if (!updatedToggles[alertId]) {
            startLoading_DisableAlert();
            handleDisable(alertId)
        } else {
            startLoading_EnableAlert();
            handleEnable(alertId);
        }
    };

    const toggleTab = tab => {
        if (activeTab !== tab) {
            setactiveTab(tab);
        }
    };

    const OffSymbol = () => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    fontSize: 12,
                    color: "#fff",
                    paddingRight: 1
                }}
            >
            </div>
        );
    };

    const OnSymbol = () => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    fontSize: 12,
                    color: "#fff",
                    paddingRight: 1
                }}
            >
            </div>
        );
    };

    const handleDisable = (alert_id) => {
        const payload = {
            'dynatrace_alert_id': alert_id,
            'enable': false
        }
        dispatch(onPostDynatraceEnableDisableAlerts(payload));
    };

    const handleEnable = (alert_id) => {
        const payload = {
            'dynatrace_alert_id': alert_id,
            'enable': true
        }
        dispatch(onPostDynatraceEnableDisableAlerts(payload));
    };

    const handleDeployStaticAlert = (resource_id, metric_id) => {
        const resource_ids = [];
        resource_ids.push(resource_id)
        const payload = {
            'dynatrace_resource_ids': resource_ids,
            'metric_id': metric_id,
        }
        dispatch(onPostDynatraceCreateResourceAlerts(payload));
    }

    const handleFormChangeDynamic = (index, event) => {
    };

    const handleFormChange = (index, event) => {
        const values = [...alerts];
        const changed_values = {...changedValues};
        const title = values[index]['dynatrace_metric']['name'];
        let newValue = event.target.type === 'number' ? parseFloat(event.target.value) : event.target.value;
        if (isNaN(newValue)) {
            newValue = event.target.value;
        }

        const getCurrentValue = (fieldName) => {
            if (changed_values[title] && changed_values[title][fieldName]) {
                return changed_values[title][fieldName].new;
            }
            return values[index][fieldName];
        };

        if (['dealerting_samples', 'violating_samples', 'samples'].includes(event.target.name)) {
            const currentSamples = getCurrentValue('samples');
            const currentDealertingSamples = getCurrentValue('dealerting_samples');
            const currentViolatingSamples = getCurrentValue('violating_samples');

            if (newValue < 0) {
                setValueError(prevState => ({ ...prevState, [event.target.name]: 'Value cannot be negative' }));
            } else if (event.target.name === 'dealerting_samples' || event.target.name === 'violating_samples') {
                if (newValue < 1 || newValue > 60) {
                    setValueError(prevState => ({ ...prevState, [event.target.name]: 'Value should be from 1 to 60' }));
                } else if (newValue > currentSamples) {
                    setValueError(prevState => ({ ...prevState, [event.target.name]: `Value should be less than samples (${currentSamples})` }));
                } else {
                    setValueError(prevState => ({ ...prevState, [event.target.name]: '' }));
                }
            } else if (event.target.name === 'samples') {
                if (newValue < 3 || newValue > 60) {
                    setValueError(prevState => ({ ...prevState, [event.target.name]: 'Value should be from 3 to 60' }));
                } else if (newValue < currentDealertingSamples || newValue < currentViolatingSamples) {
                    setValueError(prevState => ({
                        ...prevState,
                        [event.target.name]: `Value should be greater than dealerting_samples (${currentDealertingSamples}) and violating_samples (${currentViolatingSamples})`
                    }));
                } else {
                    setValueError(prevState => ({ ...prevState, [event.target.name]: '' }));
                }
            }
        }

        if (changed_values[title] === undefined) {
            changed_values[title] = {}
        }
        if (changed_values[title][event.target.name] === undefined) {
            changed_values[title][event.target.name] = {
                'id': values[index]['id'],
                'title': values[index]['dynatrace_metric']['name'],
                'name': event.target.name,
                'old': values[index][event.target.name],
                'new': newValue
            };
        } else {
            const oldValue = parseFloat(changed_values[title][event.target.name]['old']);
            if (oldValue === newValue) {
                delete changed_values[title][event.target.name];
                if (Object.keys(changed_values[title]).length === 0) {
                    delete changed_values[title];
                }
            } else {
                changed_values[title][event.target.name]['new'] = newValue;
            }
        }
        setchangedValues(changed_values);
        values[index][event.target.name] = newValue;
    };
    const startLoading_DisableAlert = () => {
        setisLoading_DisableAlert(true);

        // Simulate loading process
        setTimeout(() => {
            setisLoading_DisableAlert(false);
        }, 4000);
    };

    const startLoading_EnableAlert = () => {
        setIsLoading_EnableAlert(true);

        // Simulate loading process
        setTimeout(() => {
            setIsLoading_EnableAlert(false);
        }, 4000);
    };

    const getMatchingData = () => {
        const finalArray = [];
        if (Array.isArray(dynatrace_resource_missing_alerts) && Array.isArray(dynatrace_resource_default_threshold) && dynatrace_resource_default_threshold?.length > 0 && dynatrace_resource_missing_alerts?.length > 0) {
            dynatrace_resource_missing_alerts?.forEach(resourceAlert => {
                const matchingThreshold = dynatrace_resource_default_threshold?.find(
                    threshold => threshold?.dynatrace_metric_id === resourceAlert?.dynatrace_metric_id &&
                        threshold?.threshold_type === THRESHOLD_TYPE.STATIC
                );

                if (matchingThreshold) {
                    finalArray.push({matchingThreshold});
                }
            });
        }

        return finalArray;
    }
    const finalArray = getMatchingData();

    const customStyles = {
        zIndex: 9999,
        control: (provided, state) => ({
            ...provided,
            background: '#382b42', // Background color of the control (react-select)
            borderRadius: 0,
            color: "white",
            zIndex: 100,
            position: "relative",
            borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
        }),
        option: (provided, state) => ({
            ...provided,
            position: "relative",
            zIndex: 100,
            backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',  // Background color of dropdown options
            color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
        }),
        menu: (provided) => ({
            ...provided,
            background: '#382b42',
            position: "absolute",
            zIndex: 200, // Background color of the dropdown menu

        }),
        singleValue: (provided) => ({
            ...provided,
            position: "relative",
            color: '#ffffff', // Color of the selected value
            zIndex: 100,
        }),
    };

    return (
        <React.Fragment>
            <Row>
                <Col lg="8">
                    <Breadcrumbs
                        title={"Dynatrace Resource Alerts"}
                        breadcrumbItem={"Dynatrace Resource Alerts"}
                    />
                </Col>
            </Row>

            <Row>
                <Col md={6}>
                    <Card>
                        <CardBody>
                            <CardTitle className="mb-4 card-title">Resource Details</CardTitle>
                            <div className="table-responsive">
                                <table className="table-purple-org">
                                    <tbody>
                                    <tr>
                                        <td scope="col">Resource Name:</td>
                                        <td scope="col"><h6>{dynatrace_resource?.name}</h6></td>
                                    </tr>
                                    <tr>
                                        <td scope="col">Resource Type:</td>
                                        <td scope="col">
                                            <div className="resource-logo-display">
                                                <img
                                                    src={getDynatraceLogo(dynatrace_resource?.resource_name, dynatrace_resource?.is_application_active)}
                                                    className="resource-logo"
                                                    alt="Resource Logo"
                                                />
                                                <h6 className="mt-2">{getDynatraceName(dynatrace_resource?.resource_name)}</h6>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td scope="col">Environment:</td>
                                        <td scope="col"><h6>{dynatrace_resource?.environment}</h6></td>
                                    </tr>
                                    <tr>
                                        <td scope="col">Cloud ID:</td>
                                        <td scope="col"><h6>{dynatrace_resource?.dynatrace_reference_id}</h6></td>
                                    </tr>
                                    <tr>
                                        {
                                            (() => {
                                                const primaryChannel = notification_channel?.find(channel => channel.is_primary);
                                                if (primaryChannel?.name === 'Email') {
                                                    return (
                                                        <>
                                                            <td scope="col">Service:</td>
                                                            <td scope="col">
                                                                <Link
                                                                    to={"/temperstack-notifications/" + dynatrace_resource?.application_service_id}
                                                                    className="link-primary">
                                                                    {finalServices?.name}
                                                                </Link>
                                                            </td>
                                                        </>
                                                    )
                                                } else if (primaryChannel?.name === 'PagerDuty') {
                                                    return (
                                                        <>
                                                            <td scope="col">PagerDuty Service:</td>
                                                            <td scope="col">
                                                                <Link to={"/pagerduty-services"}
                                                                      className="link-primary">
                                                                    {finalServices?.name}
                                                                </Link>
                                                            </td>
                                                        </>
                                                    )
                                                } else if (primaryChannel?.name === 'OpsGenie') {
                                                    return (
                                                        <>
                                                            <td scope="col">OpsGenie Team:</td>
                                                            <td scope="col">
                                                                <Link to={"/opsgenie-teams"} className="link-primary">
                                                                    {finalServices?.name}
                                                                </Link>
                                                            </td>
                                                        </>
                                                    )
                                                }
                                            })()
                                        }
                                    </tr>
                                    <tr>
                                        <td scope="col">Action:</td>
                                        <td style={{display: 'flex', gap: '10px'}}>
                                            <button className="btn btn-primary w-md" onClick={() => {
                                                handleMapApplicationService();
                                            }}>
                                                Map {primaryChannel?.name === 'OpsGenie' ? 'Team' : 'Service'}
                                            </button>
                                            {
                                                dynatrace_resource?.environment === 'PRODUCTION' && <button
                                                    className={`btn btn-primary w-md ${finalServices?.name ? '' : 'disabled'}`}
                                                    disabled={!finalServices?.name} onClick={() => {
                                                    handleDefaultDeploy();
                                                }}>
                                                    Deploy Alerts
                                                </button>}
                                            {(!finalServices?.name) && (
                                                <>
                          <span
                              id="TooltipRight"
                              onMouseOver={() => settright(true)}
                              onMouseLeave={() => settright(false)}
                              className="alert-icon"
                              style={{
                                  marginLeft: '0px',
                                  alignSelf: 'center',
                              }}
                          >
                            <i className="mdi mdi-information-outline text-warning"/>
                          </span>
                                                    <Tooltip
                                                        placement="top"
                                                        isOpen={tright}
                                                        target="TooltipRight"
                                                        toggle={() => {
                                                            settright(!tright);
                                                        }}
                                                        style={{
                                                            border: "2px solid #f1b44c",
                                                            borderRadius: "8px",
                                                            backgroundColor: "#2a3042",
                                                            zIndex: 1,
                                                        }}
                                                    >
                                                        Map resource to enable deployment
                                                    </Tooltip>
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Row>
                <Col md={9}>
                </Col>
                <Col md={3}>
                    {
                        (Object.entries(changedValues).length > 0) ?
                            (
                                dynatrace_resource?.environment === 'PRODUCTION' &&
                                <div className='d-flex flex-row-reverse align-items-center gap-2'>
                                    <div>
                                        <button
                                            type="button"
                                            className={`btn btn-primary bx-pull-right w-md ${finalServices?.name ? '' : 'disabled'}`}
                                            disabled={!finalServices?.name || JSON.stringify(valueError) !== JSON.stringify({
                                                samples: '',
                                                violating_samples: '',
                                                dealerting_samples: ''
                                            })}
                                            onClick={handleSave}>
                                            Save and Deploy Alerts
                                        </button>
                                    </div>
                                    {(!finalServices?.name) && (
                                        <div>
                    <span
                        id="TooltipRight"
                        onMouseOver={() => setShowToolTip(true)}
                        onMouseLeave={() => setShowToolTip(false)}
                        className="alert-icon"
                        style={{
                            marginLeft: '0px',
                            alignSelf: 'center',
                        }}
                    >
                      <i className="mdi mdi-information-outline text-warning"/>
                    </span>
                                            <Tooltip
                                                placement="top"
                                                isOpen={showToolTip}
                                                target="TooltipRight"
                                                toggle={() => {
                                                    setShowToolTip(!showToolTip);
                                                }}
                                                style={{
                                                    border: "2px solid #f1b44c",
                                                    borderRadius: "10px",
                                                    backgroundColor: "#2a3042",
                                                    zIndex: 1,
                                                }}
                                            >
                                                Map resource to service to enable deployment
                                            </Tooltip>
                                        </div>
                                    )}
                                </div>
                            )
                            : (Object.entries(changedValuesDynamic).length > 0) ?
                                (
                                    dynatrace_resource?.environment === 'PRODUCTION' &&
                                    <>
                                        <button
                                            type="button"
                                            className={`btn btn-primary w-md`}
                                            onClick={handleSaveDynamic}
                                        >
                                            Save and Deploy Alerts
                                        </button>
                                    </>
                                )
                                : null
                    }
                </Col>
            </Row>

            {/* This is a testing for the new tab */}
            <div>
                <Nav pills className="nav-custom">
                    <NavItem className="nav-item-custom">
                        <NavLink
                            className={classnames({
                                active: activeTab === "1",
                            })}
                            onClick={() => {
                                toggleTab("1");
                            }}
                        >
                            <span className="d-sm-block">Static Alerts</span>
                        </NavLink>
                    </NavItem>
                    <NavItem className="nav-item-custom">
                        <NavLink
                            className={classnames({
                                active: activeTab === "2",
                            })}
                            onClick={() => {
                                toggleTab("2");
                            }}
                        >
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <span className="d-sm-block"
                                      style={{marginRight: '10px'}}>Anomaly Detection Alerts</span>
                                <span
                                    id="TooltipAnomaly"
                                    onMouseOver={() => settanomaly(true)}
                                    onMouseLeave={() => settanomaly(false)}
                                    className="alert-icon"
                                    style={{marginRight: '10px'}}
                                >
                <i className="mdi mdi-information-outline text-warning"/>
              </span>
                                <Tooltip
                                    placement="right"
                                    isOpen={tanomaly}
                                    target="TooltipAnomaly"
                                    toggle={() => {
                                        settanomaly(!tanomaly);
                                    }}
                                    style={{
                                        border: "2px solid #f1b44c",
                                        borderRadius: "10px",
                                        backgroundColor: "#2a3042",
                                        zIndex: 1
                                    }}
                                >
                                    Anomaly Alerts are not considered in ALCOM score
                                </Tooltip>
                            </div>
                        </NavLink>
                    </NavItem>
                </Nav>

                <hr style={{
                    border: "1px solid #556ee6",
                    backgroundColor: "#556ee6",
                    width: "100%",
                    marginTop: "-1px",
                }}/>

                <TabContent activeTab={activeTab} className="py-4">
                    <TabPane tabId="1">
                        <div>
                            <Row className="resource-header">
                                <Col lg={12}>
                                    <UncontrolledAccordion key={accordionKey} defaultOpen={defaultOpen}
                                                           className="custom-accordion">
                                        <Fragment>
                                            <AccordionItem style={{borderBottom: "groove"}}>
                                                <AccordionHeader targetId={"1"}>
                                                    <Row className="full-width">
                                                        <Col lg="6">
                                                            <h5 className="change-table-text">Alerts Deployed</h5>
                                                        </Col>
                                                    </Row>
                                                </AccordionHeader>
                                                <AccordionBody accordionId={"1"}>
                                                    <Row className="resource-header">
                                                        <Col md="3">
                                                            <div className="mb-2">
                                                                Name
                                                            </div>
                                                        </Col>
                                                        <Col md="1">
                                                            <div className="mb-2">
                                                                Aggregator
                                                            </div>
                                                        </Col>
                                                        <Col md="1">
                                                            <div className="mb-2">
                                                                Unit
                                                            </div>
                                                        </Col>
                                                        <Col md="2">
                                                            <div className="mb-2">
                                                                Threshold Operator
                                                            </div>
                                                        </Col>
                                                        <Col md="1">
                                                            <div className="mb-2">
                                                                Value
                                                            </div>
                                                        </Col>
                                                        <Col md="1">
                                                            <div className="mb-2">
                                                                Samples
                                                                {valueError.samples && <p className="invalid-error">{valueError.samples}</p>}
                                                            </div>
                                                        </Col>
                                                        <Col md="1">
                                                            <div className="mb-2">
                                                                Violating Samples
                                                                {valueError.violating_samples && <p className="invalid-error">{valueError.violating_samples}</p>}
                                                            </div>
                                                        </Col>
                                                        <Col md="1">
                                                            <div className="mb-2">
                                                                De alerting Samples
                                                                {valueError.dealerting_samples && <p className="invalid-error">{valueError.dealerting_samples}</p>}
                                                            </div>
                                                        </Col>
                                                        <Col md="1">
                                                            <div className="mb-2">
                                                                Actions
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {alerts?.length > 0 && alerts?.some(alert => alert.threshold_type === THRESHOLD_TYPE.STATIC) ? (
                                                            alerts.map((alert, index) => {
                                                                if (alert.threshold_type === THRESHOLD_TYPE.STATIC) {
                                                                    return (
                                                                        <div className="alerts-carditem" key={index}>
                                                                            <CardBody>
                                                                                <Row>
                                                                                    <Col md="3"
                                                                                         className="padding-t-10 mt-2">
                                                                                        {alert?.name}
                                                                                    </Col>
                                                                                    <Col md="1"
                                                                                         className="padding-t-10 mt-2">
                                                                                        {alert?.threshold_aggregator}
                                                                                    </Col>
                                                                                    <Col md="1"
                                                                                         className="padding-t-10 mt-2">
                                                                                        {alert?.dynatrace_metric.unit}
                                                                                    </Col>
                                                                                    <Col md="2" className="padding-t-10">
                                                                                        <select
                                                                                            id="formrow-InputState"
                                                                                            name="threshold_operator"
                                                                                            className={"form-control " + (changedValues[alert?.dynatrace_metric.name] === undefined ? "" : (changedValues[alert.dynatrace_metric.name]['threshold_operator'] === undefined ? "" : " border-warning"))}
                                                                                            value={alert?.threshold_operator}
                                                                                            onChange={event => handleFormChange(index, event)}
                                                                                        >
                                                                                            {ThresholdCondition.map((item, key) => (
                                                                                                <option key={key}
                                                                                                        value={item}>{item}</option>))}
                                                                                        </select>
                                                                                    </Col>
                                                                                    <Col md="1" className="padding-t-10">
                                                                                        <input
                                                                                            type="number"
                                                                                            value={alert?.threshold_value}
                                                                                            name="threshold_value"
                                                                                            className={"form-control " + (changedValues[alert.dynatrace_metric.name] === undefined ? "" : (changedValues[alert.dynatrace_metric.name]['threshold_value'] === undefined ? "" : " border-warning"))}
                                                                                            id="autoSizingInputGroup"
                                                                                            placeholder="Threshold Value"
                                                                                            onChange={event => handleFormChange(index, event)}
                                                                                        />
                                                                                    </Col>
                                                                                    <Col md="1" className="padding-t-10">
                                                                                        <input
                                                                                            type="number"
                                                                                            value={alert?.samples}
                                                                                            name="samples"
                                                                                            className={"form-control " + (changedValues[alert.dynatrace_metric.name] === undefined ? "" : (changedValues[alert.dynatrace_metric.name]['threshold_value'] === undefined ? "" : " border-warning"))}
                                                                                            id="autoSizingInputGroup"
                                                                                            placeholder="Samples"
                                                                                            onChange={event => handleFormChange(index, event)}
                                                                                        />
                                                                                    </Col>
                                                                                    <Col md="1" className="padding-t-10">
                                                                                        <input
                                                                                            type="number"
                                                                                            value={alert?.violating_samples}
                                                                                            name="violating_samples"
                                                                                            className={"form-control " + (changedValues[alert.dynatrace_metric.name] === undefined ? "" : (changedValues[alert.dynatrace_metric.name]['threshold_value'] === undefined ? "" : " border-warning"))}
                                                                                            id="autoSizingInputGroup"
                                                                                            placeholder="Violating Samples"
                                                                                            onChange={event => handleFormChange(index, event)}
                                                                                        />
                                                                                    </Col>
                                                                                    <Col md="1" className="padding-t-10">
                                                                                        <input
                                                                                            type="number"
                                                                                            value={alert?.dealerting_samples}
                                                                                            name="dealerting_samples"
                                                                                            className={"form-control " + (changedValues[alert.dynatrace_metric.name] === undefined ? "" : (changedValues[alert.dynatrace_metric.name]['threshold_value'] === undefined ? "" : " border-warning"))}
                                                                                            id="autoSizingInputGroup"
                                                                                            placeholder="Dealering Samples"
                                                                                            onChange={event => handleFormChange(index, event)}
                                                                                        />
                                                                                    </Col>
                                                                                    <Col md="1" className="padding-t-10">
                                                                                        {
                                                                                            alert.enabled ?
                                                                                                (
                                                                                                    <>
                                                                                                        <div
                                                                                                            id="TooltipTop"
                                                                                                            onMouseOver={() => settop(true)}
                                                                                                            onMouseLeave={() => settop(false)}
                                                                                                            className="alert-icon"
                                                                                                        >
                                                                                                            <Switch
                                                                                                                uncheckedIcon={
                                                                                                                    <OffSymbol/>}
                                                                                                                checkedIcon={
                                                                                                                    <OnSymbol/>}
                                                                                                                className="me-1 mb-sm-8 mb-2"
                                                                                                                onColor="#34c38f"
                                                                                                                offColor="#f46a6a"
                                                                                                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                                                                                activeBoxShadow="0px 0px 1px 5px"
                                                                                                                height={20}
                                                                                                                width={44}
                                                                                                                onChange={() => toggleAlert(index, alert.id)}
                                                                                                                checked={toggles[alert.id] || false}
                                                                                                            /></div>
                                                                                                        <Tooltip
                                                                                                            placement="top"
                                                                                                            isOpen={ttop}
                                                                                                            target="TooltipTop"
                                                                                                            toggle={() => {
                                                                                                                settop(!ttop);
                                                                                                            }}
                                                                                                            style={{
                                                                                                                border: "2px solid #f1b44c",
                                                                                                                borderRadius: "10px",
                                                                                                                backgroundColor: "#2a3042",
                                                                                                                zIndex: 1
                                                                                                            }}
                                                                                                        >
                                                                                                            Enable/Disable
                                                                                                            the alert
                                                                                                        </Tooltip>
                                                                                                    </>
                                                                                                ) :
                                                                                                (
                                                                                                    <>
                                                                                                        <div
                                                                                                            id="DisabledTooltipTop"
                                                                                                            onMouseOver={() => setdtop(true)}
                                                                                                            onMouseLeave={() => setdtop(false)}
                                                                                                            className="alert-icon"
                                                                                                        >
                                                                                                            <Switch
                                                                                                                uncheckedIcon={
                                                                                                                    <OffSymbol/>}
                                                                                                                className="me-1 mb-sm-8 mb-2"
                                                                                                                offColor="#f46a6a"
                                                                                                                onColor="#34c38f"
                                                                                                                height={20}
                                                                                                                width={44}
                                                                                                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                                                                                activeBoxShadow="0px 0px 1px 5px"
                                                                                                                onChange={() => toggleAlert(index, alert.id)}
                                                                                                                checked={false}
                                                                                                            /></div>
                                                                                                        <Tooltip
                                                                                                            placement="top"
                                                                                                            isOpen={dttop}
                                                                                                            target="DisabledTooltipTop"
                                                                                                            toggle={() => {
                                                                                                                setdtop(!dttop);
                                                                                                            }}
                                                                                                            style={{
                                                                                                                border: "2px solid #f1b44c",
                                                                                                                borderRadius: "10px",
                                                                                                                backgroundColor: "#2a3042",
                                                                                                                zIndex: 1
                                                                                                            }}
                                                                                                        >
                                                                                                            Enable/Disable
                                                                                                            the alert
                                                                                                        </Tooltip>
                                                                                                    </>
                                                                                                )
                                                                                        }
                                                                                    </Col>
                                                                                </Row>
                                                                            </CardBody>
                                                                        </div>
                                                                    )
                                                                }
                                                            }))
                                                        : alerts?.length === 0 || !alerts?.some(alert => alert.threshold_type === THRESHOLD_TYPE.STATIC) ? (
                                                            <Row className="justify-content-center align-items-center"
                                                                 style={{textAlign: 'center'}}>
                                                                <Col md="6">
                                                                    <h5>No alerts are deployed</h5>
                                                                </Col>
                                                            </Row>
                                                        ) : null
                                                    }
                                                </AccordionBody>
                                            </AccordionItem>
                                        </Fragment>
                                        <Loader
                                            isOpen={isLoading_DisableAlert}
                                            lottieJson={deployAlertsLottie}
                                            messageHeader="Disabling Alert"
                                            message="The alert is not deleted. You can enable it any time again."
                                        />
                                        <Loader
                                            isOpen={isLoading_EnableAlert}
                                            lottieJson={deployAlertsLottie}
                                            messageHeader="Enabling Alert"
                                            message="That was easy! Hang tight while we enable your alert again."
                                        />
                                        <Fragment>
                                            <AccordionItem>
                                                <AccordionHeader targetId={"2"}>
                                                    <Row className="full-width">
                                                        <Col lg="6">
                                                            <h5 className="change-table-text">Alerts Missing</h5>
                                                        </Col>
                                                    </Row>
                                                </AccordionHeader>
                                                <AccordionBody accordionId={"2"}>
                                                    {finalArray?.length === 0 ? (
                                                        <Row className="justify-content-center align-items-center"
                                                             style={{textAlign: 'center'}}>
                                                            <Col md="6">
                                                                <h5>Good job!!! No alerts missing</h5>
                                                            </Col>
                                                        </Row>
                                                    ) : finalArray?.length > 0 ? (
                                                        <div className="table-responsive react-table">
                                                            <Table bordered hover className="table-purple">
                                                                <thead className="table-light table-nowrap">
                                                                <tr>
                                                                    {headers.map((header, index) => (
                                                                        <th key={index}>
                                                                            <div className="mb-2">
                                                                                {header}
                                                                            </div>
                                                                        </th>
                                                                    ))}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {finalArray?.map((alert, index) => {
                                                                    return (
                                                                        <Fragment key={index}>
                                                                            <tr>
                                                                                <td>
                                                                                    {alert?.matchingThreshold?.metric?.name}
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="text"
                                                                                        id="autoSizingInputGroup"
                                                                                        name="threshold_operator"
                                                                                        className="input"
                                                                                        value={alert?.matchingThreshold?.threshold_operator}
                                                                                        placeholder="Threshold Operator"
                                                                                        readOnly
                                                                                    >
                                                                                    </input>
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={alert?.matchingThreshold?.threshold_value}
                                                                                        name="threshold_value"
                                                                                        className="input"
                                                                                        id="autoSizingInputGroup"
                                                                                        placeholder="Threshold Value"
                                                                                        readOnly
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    {alert?.matchingThreshold?.metric.unit}
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={alert?.matchingThreshold?.samples}
                                                                                        name="samples"
                                                                                        className="input"
                                                                                        id="autoSizingInputGroup"
                                                                                        placeholder="Samples"
                                                                                        readOnly
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={alert?.matchingThreshold?.violating_samples}
                                                                                        name="violating_samples"
                                                                                        className="input"
                                                                                        id="autoSizingInputGroup"
                                                                                        placeholder="Violating Samples"
                                                                                        readOnly
                                                                                    />
                                                                                </td>
                                                                                <td style={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center'
                                                                                }}>
                                                                                    <button
                                                                                        className="btn btn-primary bx-pull-right w-md"
                                                                                        onClick={() => handleDeployStaticAlert(params.resourceId, alert?.matchingThreshold?.dynatrace_metric_id)}
                                                                                        disabled={!finalServices?.name}
                                                                                    >
                                                                                        Deploy Alert
                                                                                    </button>
                                                                                    {(!finalServices?.name) && (
                                                                                        <>
                                                                                            <span
                                                                                                id={`TooltipStatic-${index}`}
                                                                                                onMouseOver={() => showTooltipStatic(alert?.matchingThreshold?.dynatrace_metric_id)}
                                                                                                onMouseLeave={() => hideTooltipStatic(alert?.matchingThreshold?.dynatrace_metric_id)}
                                                                                                className="alert-icon"
                                                                                            >
                                                                                              <i className="mdi mdi-information-outline text-warning"/>
                                                                                            </span>
                                                                                            <Tooltip
                                                                                                placement="top"
                                                                                                isOpen={tooltipstatic[alert?.matchingThreshold?.dynatrace_metric_id]}
                                                                                                target={`TooltipStatic-${index}`}
                                                                                                style={{
                                                                                                    border: "2px solid #f1b44c",
                                                                                                    borderRadius: "10px",
                                                                                                    backgroundColor: "#2a3042",
                                                                                                    zIndex: 1,
                                                                                                }}
                                                                                            >
                                                                                                Map resource to enable
                                                                                                deployment
                                                                                            </Tooltip>
                                                                                        </>
                                                                                    )}
                                                                                </td>
                                                                            </tr>
                                                                        </Fragment>
                                                                    );
                                                                })}
                                                                </tbody>
                                                            </Table>
                                                        </div>) : null}
                                                </AccordionBody>
                                            </AccordionItem>
                                        </Fragment>
                                    </UncontrolledAccordion>
                                </Col>
                            </Row>
                        </div>
                    </TabPane>

                    <TabPane tabId="2">
                        <div>
                            <Row className="resource-header">
                                <Col lg={12}>
                                    <UncontrolledAccordion key={accordionKeyDynamic} defaultOpen={defaultOpenDynamic}
                                                           className="custom-accordion">
                                        <Fragment>
                                            <AccordionItem style={{borderBottom: "groove"}}>
                                                <AccordionHeader targetId={"1"}>
                                                    <Row className="full-width">
                                                        <Col lg="6">
                                                            <h5 className="change-table-text">Alerts Deployed</h5>
                                                        </Col>
                                                    </Row>
                                                </AccordionHeader>
                                                <AccordionBody accordionId={"1"}>
                                                    <Row className="resource-header">
                                                        <Col md="3">
                                                            <div className="mb-2">
                                                                Name
                                                            </div>
                                                        </Col>
                                                        <Col md="2">
                                                            <div className="mb-2">
                                                                Metric Name
                                                            </div>
                                                        </Col>
                                                        <Col md="3">
                                                            <div className="mb-2">
                                                                Baseline Direction
                                                            </div>
                                                        </Col>
                                                        <Col md="1">
                                                            <div className="mb-2">
                                                                Deviation Count
                                                            </div>
                                                        </Col>
                                                        <Col md="1">
                                                            <div className="mb-2">
                                                                Threshold Duration
                                                            </div>
                                                        </Col>
                                                        <Col md="1">
                                                            <div className="mb-2">
                                                                Time Function
                                                            </div>
                                                        </Col>
                                                        <Col md="1">
                                                            <div className="mb-2">
                                                                Actions
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {dynatrace_dynamic_alerts.alerts?.length > 0 ? (
                                                            dynatrace_dynamic_alerts.alerts?.map((alert, index) => {
                                                                return (
                                                                    <div className="header" key={index}>
                                                                        <CardBody>
                                                                            <Row>
                                                                                <Col md="3" className="padding-t-10 mt-2">
                                                                                    {alert.name}
                                                                                </Col>
                                                                                <Col md="2" className="padding-t-10 mt-2">
                                                                                    {alert.new_relic_metric.name}
                                                                                </Col>
                                                                                <Col md="3" className="padding-t-10">
                                                                                    <select
                                                                                        id="formrow-InputState"
                                                                                        name="threshold_operator"
                                                                                        className={"form-control " + (changedValuesDynamic[alert.app_dynamics_metric.name] === undefined ? "" : (changedValuesDynamic[alert.app_dynamics_metric.name]['threshold_operator'] === undefined ? "" : " border-warning"))}
                                                                                        value={alert.threshold_operator}
                                                                                        onChange={event => handleFormChangeDynamic(index, event)}
                                                                                    >
                                                                                        {ThresholdConditionDynamic.map((item, key) => (
                                                                                            <option key={key}
                                                                                                    value={item}>{item}</option>))}
                                                                                    </select>
                                                                                </Col>
                                                                                <Col md="1" className="padding-t-10">
                                                                                    <input
                                                                                        type="number"
                                                                                        value={alert.deviation_count}
                                                                                        name="deviation_count"
                                                                                        className={"form-control " + (changedValuesDynamic[alert.app_dynamics_metric.name] === undefined ? "" : (changedValuesDynamic[alert.app_dynamics_metric.name]['deviation_count'] === undefined ? "" : " border-warning"))}
                                                                                        id="autoSizingInputGroup"
                                                                                        placeholder="Deviation Count"
                                                                                        onChange={event => handleFormChangeDynamic(index, event)}
                                                                                    />
                                                                                </Col>
                                                                                <Col md="1" className="padding-t-10">
                                                                                    <input
                                                                                        type="number"
                                                                                        value={alert.threshold_duration}
                                                                                        name="threshold_duration"
                                                                                        className={"form-control " + (changedValuesDynamic[alert.app_dynamics_metric.name] === undefined ? "" : (changedValuesDynamic[alert.app_dynamics_metric.name]['threshold_duration'] === undefined ? "" : " border-warning"))}
                                                                                        id="autoSizingInputGroup"
                                                                                        placeholder="Threshold Duration"
                                                                                        onChange={event => handleFormChangeDynamic(index, event)}
                                                                                    />
                                                                                </Col>
                                                                                <Col md="1" className="padding-t-10 mt-2">
                                                                                    {alert.time_function}
                                                                                </Col>
                                                                                <Col md="1" className="padding-t-10">
                                                                                    {
                                                                                        alert.enabled ?
                                                                                            (
                                                                                                <>
                                                                                                    <div
                                                                                                        id="TooltipTop"
                                                                                                        onMouseOver={() => settop(true)}
                                                                                                        onMouseLeave={() => settop(false)}
                                                                                                        className="alert-icon"
                                                                                                    >
                                                                                                        <Switch
                                                                                                            uncheckedIcon={
                                                                                                                <OffSymbol/>}
                                                                                                            checkedIcon={
                                                                                                                <OnSymbol/>}
                                                                                                            className="me-1 mb-sm-8 mb-2"
                                                                                                            onColor="#34c38f"
                                                                                                            offColor="#f46a6a"
                                                                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                                                                            activeBoxShadow="0px 0px 1px 5px"
                                                                                                            height={20}
                                                                                                            width={44}
                                                                                                            onChange={() => toggleAlertDynamic(index, alert.id)}
                                                                                                            checked={togglesDynamic[alert.id] || false}
                                                                                                        /></div>
                                                                                                    <Tooltip
                                                                                                        placement="top"
                                                                                                        isOpen={ttop}
                                                                                                        target="TooltipTop"
                                                                                                        toggle={() => {
                                                                                                            settop(!ttop);
                                                                                                        }}
                                                                                                        style={{
                                                                                                            border: "2px solid #f1b44c",
                                                                                                            borderRadius: "10px",
                                                                                                            backgroundColor: "#2a3042",
                                                                                                            zIndex: 1
                                                                                                        }}
                                                                                                    >
                                                                                                        Enable/Disable the
                                                                                                        alert
                                                                                                    </Tooltip>
                                                                                                </>
                                                                                            ) :
                                                                                            (
                                                                                                <>
                                                                                                    <div
                                                                                                        id="DisabledTooltipTop"
                                                                                                        onMouseOver={() => setdtop(true)}
                                                                                                        onMouseLeave={() => setdtop(false)}
                                                                                                        className="alert-icon"
                                                                                                    >
                                                                                                        <Switch
                                                                                                            uncheckedIcon={
                                                                                                                <OffSymbol/>}
                                                                                                            className="me-1 mb-sm-8 mb-2"
                                                                                                            offColor="#f46a6a"
                                                                                                            onColor="#34c38f"
                                                                                                            height={20}
                                                                                                            width={44}
                                                                                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                                                                            activeBoxShadow="0px 0px 1px 5px"
                                                                                                            onChange={() => toggleAlertDynamic(index, alert.id)}
                                                                                                            checked={false}
                                                                                                        /></div>
                                                                                                    <Tooltip
                                                                                                        placement="top"
                                                                                                        isOpen={dttop}
                                                                                                        target="DisabledTooltipTop"
                                                                                                        toggle={() => {
                                                                                                            setdtop(!dttop);
                                                                                                        }}
                                                                                                        style={{
                                                                                                            border: "2px solid #f1b44c",
                                                                                                            borderRadius: "10px",
                                                                                                            backgroundColor: "#2a3042",
                                                                                                            zIndex: 1
                                                                                                        }}
                                                                                                    >
                                                                                                        Enable/Disable the
                                                                                                        alert
                                                                                                    </Tooltip>
                                                                                                </>
                                                                                            )
                                                                                    }
                                                                                </Col>
                                                                            </Row>
                                                                        </CardBody>
                                                                    </div>
                                                                )
                                                            }))
                                                        : dynatrace_dynamic_alerts.alerts?.length === 0 ? (
                                                            <Row className="justify-content-center align-items-center"
                                                                 style={{textAlign: 'center'}}>
                                                                <Col md="6">
                                                                    <h5>
                                                                        No alerts are deployed
                                                                    </h5>
                                                                </Col>
                                                            </Row>
                                                        ) : <Row className="justify-content-center align-items-center"
                                                                 style={{textAlign: 'center'}}>
                                                            <Col md="6">
                                                                <h5>
                                                                    Coming Soon!
                                                                </h5>
                                                            </Col>
                                                        </Row>
                                                    }
                                                </AccordionBody>
                                            </AccordionItem>
                                        </Fragment>
                                        <Loader
                                            isOpen={isLoading_DisableAlert}
                                            lottieJson={deployAlertsLottie}
                                            messageHeader="Disabling Alert"
                                            message="The alert is not deleted. You can enable it any time again."
                                        />
                                        <Loader
                                            isOpen={isLoading_EnableAlert}
                                            lottieJson={deployAlertsLottie}
                                            messageHeader="Enabling Alert"
                                            message="That was easy! Hang tight while we enable your alert again."
                                        />
                                        <Fragment>
                                            <AccordionItem>
                                                <AccordionHeader targetId={"2"}>
                                                    <Row className="full-width">
                                                        <Col lg="6">
                                                            <h5 className="change-table-text">Alerts Missing</h5>
                                                        </Col>
                                                    </Row>
                                                </AccordionHeader>
                                                <AccordionBody accordionId={"2"}>
                                                    {dynatrace_missing_dynamic_alerts.alerts?.length === 0 ? (
                                                        <Row className="justify-content-center align-items-center"
                                                             style={{textAlign: 'center'}}>
                                                            <Col md="6">
                                                                <h5>
                                                                    {dynatrace_resource?.resource_name === 'apm_app' ? 'No Alerts Available' : 'Coming Soon!'}
                                                                </h5>
                                                            </Col>
                                                        </Row>
                                                    ) : dynatrace_missing_dynamic_alerts.alerts?.length > 0 ? (
                                                        <div className="table-responsive react-table">
                                                            <Table bordered hover className="table-purple">
                                                                <thead className="table-light table-nowrap">
                                                                <tr>
                                                                    {headersDynamic.map((header, index) => (
                                                                        <th key={index}>
                                                                            <div className="mb-2">
                                                                                {header}
                                                                            </div>
                                                                        </th>
                                                                    ))}
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {dynatrace_missing_dynamic_alerts.alerts?.map((alert, index) => {
                                                                    return (
                                                                        <Fragment key={index}>
                                                                            <tr>
                                                                                <td>
                                                                                    {alert?.metric?.name}
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="text"
                                                                                        id="autoSizingInputGroup"
                                                                                        name="threshold_operator"
                                                                                        className="input"
                                                                                        value={alert?.threshold_operator}
                                                                                        placeholder="Baseline Direction"
                                                                                        readOnly
                                                                                    >
                                                                                    </input>
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={alert?.deviation_count}
                                                                                        name="threshold_value"
                                                                                        className="input"
                                                                                        id="autoSizingInputGroup"
                                                                                        placeholder="Threshold Value"
                                                                                        readOnly
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        value={alert?.threshold_duration}
                                                                                        name="duration"
                                                                                        className="input"
                                                                                        id="autoSizingInputGroup"
                                                                                        placeholder="Duration"
                                                                                        readOnly
                                                                                    />
                                                                                </td>
                                                                                <td style={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center'
                                                                                }}>
                                                                                    <button
                                                                                        className="btn btn-primary bx-pull-right w-md"
                                                                                        onClick={() => handleDeployDynamicAlert(params.resourceId, alert?.id)}
                                                                                        disabled={!finalServices?.name}
                                                                                    >
                                                                                        Deploy Alert
                                                                                    </button>
                                                                                    {!finalServices?.name && (
                                                                                        <>
                                              <span
                                                  id={`tooltipDynamic-${alert?.id}`}
                                                  onMouseOver={() => showTooltipDynamic(alert?.id)}
                                                  onMouseLeave={() => hideTooltipDynamic(alert?.id)}
                                                  className="alert-icon"
                                              >
                                                <i className="mdi mdi-information-outline text-warning"/>
                                              </span>
                                                                                            <Tooltip
                                                                                                placement="top"
                                                                                                isOpen={tooltipdynamic[alert?.id]}
                                                                                                target={`tooltipDynamic-${alert?.id}`}
                                                                                                style={{
                                                                                                    border: "2px solid #f1b44c",
                                                                                                    borderRadius: "10px",
                                                                                                    backgroundColor: "#2a3042",
                                                                                                    zIndex: 1,
                                                                                                }}
                                                                                            >
                                                                                                Map resource to enable
                                                                                                deployment
                                                                                            </Tooltip>
                                                                                        </>
                                                                                    )}
                                                                                </td>
                                                                            </tr>
                                                                        </Fragment>
                                                                    );
                                                                })}
                                                                </tbody>
                                                            </Table>
                                                        </div>) : null}
                                                </AccordionBody>
                                            </AccordionItem>
                                        </Fragment>
                                    </UncontrolledAccordion>
                                </Col>
                            </Row>
                        </div>
                    </TabPane>
                </TabContent>
            </div>

            <Modal isOpen={mapServiceModal} role="dialog" autoFocus={true} keyboard={false} centered backdrop="static"
                   data-toggle="modal">
                <div className="d-flex justify-content-center">
                    <ModalHeader className="border-bottom-2">
                        <span className="modal-header-resource">Map Resources to Application Service</span>
                    </ModalHeader>
                </div>
                <div className="modal-body">
                    <Row className="full-width">
                        <Col lg="12" className="">
                            {
                                (() => {
                                    if (primaryChannel?.name === 'Email') {
                                        return (
                                            <h5 className="text-primary select-service mb-3">Select Application
                                                Service</h5>
                                        )
                                    } else if (primaryChannel?.name === 'PagerDuty') {
                                        return (
                                            <h5 className="text-primary select-service mb-3">Select PagerDuty
                                                Service</h5>
                                        )
                                    } else if (primaryChannel?.name === 'OpsGenie') {
                                        return (
                                            <h5 className="text-primary select-service mb-3">Select OpsGenie Team</h5>
                                        )
                                    }
                                })()
                            }
                            <div className="text-center mb-4">
                                <div className="row justify-content-center">
                                    <div className="col-xl-10">
                                        <div className="mb-2">
                                            <Select
                                                isClearable
                                                value={serviceOptions?.find(option => option.label === selectedService)}
                                                options={[
                                                    ...serviceOptions,
                                                    {value: "/add-service", label: "Add new service"}
                                                ]}
                                                placeholder={
                                                    primaryChannel?.name === 'Email' ? 'Select an Application Service' :
                                                        primaryChannel?.name === 'PagerDuty' ? 'Select a PagerDuty Service' :
                                                            primaryChannel?.name === 'OpsGenie' ? 'Select an OpsGenie Team' :
                                                                'Select a Service'
                                                }
                                                onChange={(selectedOption) => {
                                                    if (selectedOption && selectedOption.value === "/add-service") {
                                                        window.location.href = "/add-service";
                                                    } else {
                                                        handleServiceFormChange(selectedOption);
                                                    }
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 0,
                                                    colors: {
                                                        ...theme.colors,
                                                        neutral0: '#222736',
                                                        neutral5: '#485EC4',
                                                        neutral10: '#485EC4',
                                                        neutral60: '#ffffff',
                                                        neutral70: '#ffffff',
                                                        neutral80: '#ffffff',
                                                        neutral90: '#ffffff',
                                                        primary: '#485EC4',
                                                    },
                                                })}
                                                getOptionLabel={(option) => customOptionRenderer(option)}
                                                styles={customStyles}
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <Select
                                                isClearable
                                                value={environments.find(env => env.value === selectedEnvironment)}
                                                options={environments}
                                                placeholder="Select an Environment"
                                                onChange={event => handleEnvironmentChange(event)}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 0,
                                                    colors: {
                                                        ...theme.colors,
                                                        neutral0: '#222736',
                                                        neutral5: '#485EC4',
                                                        neutral10: '#485EC4',
                                                        neutral60: '#ffffff',
                                                        neutral70: '#ffffff',
                                                        neutral80: '#ffffff',
                                                        neutral90: '#ffffff',
                                                        primary: '#485EC4',
                                                    },
                                                })}
                                                styles={customStyles}
                                            />
                                        </div>
                                        <Row className="full-width mt-4 pt-4">
                                            <Col lg="6" className="mt-4">
                                                <Link onClick={cancelMapServiceModal}
                                                      className="btn btn-secondary w-md">Cancel</Link>
                                            </Col>
                                            <Col lg="6" className="mt-4">
                                                <Link onClick={() => {
                                                    startLoading1();
                                                    handleServiceMapping();
                                                }}
                                                      className="btn btn-primary w-md">Map {primaryChannel?.name === 'OpsGenie' ? 'Team' : 'Service'}</Link>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Modal>

            <Modal isOpen={DynatraceDeployModal} role="dialog" autoFocus={true} keyboard={false} centered
                   backdrop="static" data-toggle="modal">
                <div>
                    <ModalHeader className="border-bottom-2">
                        <span className="modal-header-resource">Deploy Default Alerts</span>
                    </ModalHeader>
                </div>
                <div className="modal-body">
                    <Row className="full-width">
                        <Col lg="12" className="mt-4">
                            <div className="text-center mb-4">
                                <div className="row justify-content-center">
                                    <div className="col-xl-10">
                                        <h4 className="text-primary">Are you sure you want to deploy these alerts?</h4>
                                        <h6 className="mt-4">
                                            This will deploy ALL the default alerts for the selected resources. Please
                                            review the{' '}
                                            <Link to='/new-relic-thresholds' target="_blank">
                                                default thresholds
                                            </Link>{' '}
                                            and modify, if required.
                                        </h6>
                                        <Row className="full-width">
                                            <Col lg="6" className="mt-4">
                                                <Link onClick={cancelDeployModal} className="btn btn-secondary w-md">
                                                    Cancel
                                                </Link>
                                            </Col>
                                            <Col lg="6" className="mt-4">
                                                <Link className="btn btn-primary w-md" onClick={() => {
                                                    startLoading2();
                                                    handleDeploy();
                                                }}>
                                                    Deploy
                                                </Link>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Modal>
            <Modal
                isOpen={subscribemodal}
                role="dialog"
                autoFocus={true}
                centered={true}
                className="exampleModal"
                size="xl"
                tabIndex="-1"
            >
                <div className="modal-header border-bottom-1 text-center">
                    <h4 className="text-primary">Changing thresholds for the alert!</h4>
                    <button type="button" className="btn-close"
                            onClick={() => {
                                setSubscribemodal(!subscribemodal);
                            }}
                            aria-label="Close"
                    >
                    </button>
                </div>
                <div className="modal-body">
                    <div className="text-center mb-4">
                        <div className="row justify-content-center">
                            <div className="col-xl-10">
                                <p className="font-size-14 mb-4">
                                    Note: This does not affect your default thresholds. Only this alert will be
                                    modified.
                                </p>
                                <div className="table-responsive react-table">
                                    <Table bordered hover className="table-purple">
                                        <thead className="table-light table-nowrap">
                                        <tr>
                                            <th>Alert Name</th>
                                            {changeHeaders.map((header, index) => (
                                                <th key={index}>
                                                    <div className="mb-2">
                                                        {header}
                                                    </div>
                                                </th>
                                            ))}
                                        </tr>
                                        </thead>
                                        {
                                            Object.entries(changedValues).map(([parent_key, changedValue], index) => {
                                                return (
                                                    <Fragment key={index}>
                                                        <tbody>
                                                        {
                                                            Object.entries(changedValue).map(([key, value], index2) => {
                                                                return (
                                                                    <Fragment key={index2}>
                                                                        <tr>
                                                                            <td>
                                                                                {parent_key}
                                                                            </td>
                                                                            <td>
                                                                                {value.name}
                                                                            </td>
                                                                            <td>
                                                                                {value.old}
                                                                            </td>
                                                                            <td>
                                                                                <b>{value.new}</b>
                                                                            </td>
                                                                        </tr>
                                                                    </Fragment>
                                                                )
                                                            })
                                                        }
                                                        </tbody>

                                                    </Fragment>
                                                )
                                            })
                                        }
                                    </Table>
                                    <Button
                                        color="primary"
                                        type="button"
                                        id="button-addon2"
                                        onClick={() => {
                                            startLoading_SaveAlert();
                                            setSubscribemodal(!subscribemodal);
                                            handleSubmit();
                                        }}
                                    >
                                        Deploy Alerts
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                isOpen={deployModalDynamic}
                role="dialog"
                autoFocus={true}
                centered={true}
                className="exampleModal"
                size="xl"
                tabIndex="-1"
            >
                <div className="modal-header border-bottom-1 text-center">
                    <h4 className="text-primary">Changing thresholds for the alert!</h4>
                    <button type="button" className="btn-close"
                            onClick={() => {
                                setDeployModalDynamic(!deployModalDynamic);
                            }}
                            aria-label="Close"
                    >
                    </button>
                </div>
                <div className="modal-body">
                    <div className="text-center mb-4">
                        <div className="row justify-content-center">
                            <div className="col-xl-10">
                                <p className="font-size-14 mb-4">
                                    Note: This does not affect your default thresholds. Only this alert will be
                                    modified.
                                </p>
                                <div className="table-responsive react-table">
                                    <Table bordered hover className="table-purple">
                                        <thead className="table-light table-nowrap">
                                        <tr>
                                            <th>Alert Name</th>
                                            {changeHeaders.map((header, index) => (
                                                <th key={index}>
                                                    <div className="mb-2">
                                                        {header}
                                                    </div>
                                                </th>
                                            ))}
                                        </tr>
                                        </thead>
                                        {
                                            Object.entries(changedValuesDynamic).map(([parent_key, changedValue], index) => {
                                                return (
                                                    <Fragment key={index}>
                                                        <tbody>
                                                        {
                                                            Object.entries(changedValue).map(([key, value], index2) => {
                                                                return (
                                                                    <Fragment key={index2}>
                                                                        <tr>
                                                                            <td>
                                                                                {parent_key}
                                                                            </td>
                                                                            <td>
                                                                                {value.name}
                                                                            </td>
                                                                            <td>
                                                                                {value.old}
                                                                            </td>
                                                                            <td>
                                                                                <b>{value.new}</b>
                                                                            </td>
                                                                        </tr>
                                                                    </Fragment>
                                                                )
                                                            })
                                                        }
                                                        </tbody>

                                                    </Fragment>
                                                )
                                            })
                                        }
                                    </Table>
                                    <Button
                                        color="primary"
                                        type="button"
                                        id="button-addon2"
                                        onClick={() => {
                                            startLoading_SaveAlert();
                                            setDeployModalDynamic(!deployModalDynamic);
                                            handleSubmitDynamic();
                                        }}
                                    >
                                        Deploy Alerts
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <Loader
                isOpen={isLoading1}
                lottieJson={connectTeamLottie}
                messageHeader="Resource - Team Mapping"
                message="Please wait while we map the selected resources to the respective team."
            />
            <Loader
                isOpen={isLoading2}
                lottieJson={deployAlertsLottie}
                messageHeader="Deploying Alerts"
                message="That was easy! Hang tight while we deploy your alerts."
            />
            <Loader
                isOpen={isLoading_SaveAlert}
                lottieJson={savingDefaultsLottie}
                messageHeader="Saving Alert"
                message="Please wait while your alert is being updated."
            />
        </React.Fragment>
    )
}

export default DynatraceAlert;